export const SET_TAGS = 'SET_TAGS'; // взять все теги
export const SET_TAG = 'SET_TAG';   // изменить 1 тег
